<template>
  <div class="">
    <label :for="id" class="custom_input_label" v-if="label">
      {{ label }}
    </label>
    <div class="custom_select_page">
      <validation-provider
        :name="label || name || null"
        v-slot="{ errors }"
        :rules="rules"
        :vid="vid || null"
      >
        <v-select
          :error-messages="errors[0]"
          v-bind="$attrs"
          :label="placeholder"
          :item-text="itemText"
          :item-value="itemValue"
          solo
          @change="(val) => $emit('input', val)"
          :value="value"
          dense
          :id="id"
        >
          <template v-if="customItem" #item="{ item, attrs }">
            <slot name="item" :item="item" :attrs="attrs"></slot>
          </template>
          <template v-if="customSelection" v-slot:selection="{ item, index }">
            <slot name="selection" :item="item" :index="index"></slot>
          </template>
        </v-select>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import { generateText } from "@/utils/pureFunctions";

export default {
  name: "CustomSelect",
  inheritAttrs: false,
  props: {
    customSelection: {
      type: Boolean,
      default: false,
    },
    customItem: {
      type: Boolean,
      default: false,
    },
    itemText: {
      default: "name",
    },
    itemValue: {
      default: "id",
    },
    rules: {
      type: String,
      Object,
      default: null,
    },
    name: {
      type: String,
      default: "Field",
    },
    value: {},
    label: {
      type: String,
    },
    placeholder: {
      type: String,
    },
    vid: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      id: null,
    };
  },
  mounted() {
    this.id = generateText(10);
  },
};
</script>
